/**
 * Partage social (articles, offres d'emploi) : ouverture des liens dans une popup.
 * Remplace le composant Vue SocialShare.
 *
 * Non porté (décision D4) : le mode « sticky » au scroll cherchait `.app-header`, qui n'existe
 * plus dans le header, et n'a donc jamais fonctionné. À traiter dans un ticket séparé.
 */
UNYC.register('social-share', () => {
    UNYC.init('[data-social-share]', 'social-share', (root) => {
        UNYC.qsa('.links a', root).forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const name = `${link.title.toLowerCase()}-share-window`;
                const params = 'menubar=no,toolbar=no,status=no,width=480,height=480,left=100,top=100,';

                window.open(link.href, name, params);
            });
        });
    });
});
